import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import apiCall from '../../apiCall.js';

import { DELETE_ATTACHMENT, DELETE_ATTACHMENT_SUCCESS, DELETE_ATTACHMENT_ERROR } from './../../actionType.js';

function* deleteAttachment({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/delete-attachment`,
      method: 'POST',
      data: payload?.data,
      isFormData: true,
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'Project-Code': 'ADMIN_ACCESS',
      },
    });

    if (response?.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: DELETE_ATTACHMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: DELETE_ATTACHMENT_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: DELETE_ATTACHMENT_ERROR, payload: error });
  }
}

export function* watchDeleteAttachment() {
  yield takeEvery(DELETE_ATTACHMENT, deleteAttachment);
}

function* deleteAttachmentSaga() {
  yield all([fork(watchDeleteAttachment)]);
}

export default deleteAttachmentSaga;
